<template>
  <page-wrapper :title="title">
    <div class="header">
      <sc-button
        variant="primary"
        :route="{ name: 'RuejaiClubBannerCreatePage' }"
      >เพิ่ม Banner</sc-button>
    </div>
    <div class="ruejai-club-banner-row" v-for="item in list" :key="item.id">
      <div class="image-container">
        <img class="image img-fluid" :src="item.imageUrl" />
      </div>
      <div class="detail">
        <router-link :to="item.route" class="title">{{
          item.title
        }}</router-link>
        <div class="subtitle">
          <div class="label">สร้างเมื่อ</div>
          <div class="value">{{ item.createdAt }}</div>
        </div>
      </div>
    </div>
    <div class="wrapper text-right padding-adjust">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { toLocaleTH } from "@/lib/dateTime";
import { Pagination } from "element-ui";

export default {
  components: {
    PageWrapper,
    ScButton,
    "el-pagination": Pagination
  },
  data() {
    const title = "รายการ Ruejai Club Banner";
    const total = 0;
    const list = [];

    return {
      title,
      list,
      total
    };
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1
      };
    }
  },
  watch: {
    async "$route.query"(query) {
      await this.setupData();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    async setupData() {
      const { banners, count } = await this.fetchData();

      this.total = count;
      this.list = banners.map(item => {
        const route = {
          name: "RuejaiClubBannerDetailPage",
          params: { id: item.id }
        };
        const createdAt = this.formatDate(item.created_at);

        return {
          id: item.id,
          title: item.title,
          route,
          ruejaiClubPackageId: item.ruejai_club_package_id,
          createdAt,
          imageUrl: item.image_url
        };
      });
    },
    async fetchData() {
      const response = await baanRueJaiClient.admin.ruejaiClub.banners.list(
        this.queryParams
      );

      return response.data.result;
    },
    formatDate(date) {
      const format = "dd MMMM yyyy";

      return toLocaleTH(DateTime.fromISO(date)).toFormat(format);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
}

.ruejai-club-banner-row {
  padding: 15px 30px;
  display: grid;
  grid-template-columns: 150px 1fr;
  grid-gap: 30px;

  .title {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  border-bottom: $border;
}

.subtitle {
  margin-bottom: 10px;
}

.label {
  color: #777;
  font-size: 0.9rem;
}

.value {
  font-size: 1rem;
}

.note {
  font-size: 0.8rem;
}

.padding-adjust {
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/banner/pages/RuejaiClubBannerListPage.vue